import PropTypes          from 'prop-types';
import Link               from 'next/link';
import { useRouter }      from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button }         from 'semantic-ui-react';
import SiteView           from 'components/Site/View';
import UIList             from 'components/UI/List';
import ArticleItem        from 'components/Article/Item';
import isUndefined        from 'lodash/isUndefined';
import sortBy             from 'lodash/sortBy';
import styles             from './articles-by-categories.module.scss';

function ArticlesByCategoriesView ({ title, data }) {
  const { t } = useTranslation('common');
  const { category } = useRouter().query;

  const getArticles = (articles) => {
    // crutch because of backend filters bug
    const filtered = articles.filter(item => item.status === 'PUBLISHED');
    const _articles = sortBy(filtered, ['id']).reverse();

    return category ? _articles : _articles.slice(0, 3);
  };

  return (
    <SiteView title={title}>
      <div className={styles.root}>
        <For each="item" of={data} index="index">
          <div className={styles.category} key={item.slug}>
            <h2>{item.name}</h2>

            <div className={styles.items}>
              <UIList
                data={getArticles(item.articles || [])}
                itemComponent={ArticleItem}
                itemComponentProps={{ showCategory: false }}
              />
            </div>

            <If condition={isUndefined(category)}>
              <div className={styles.more}>
                <Link href={`/articles?category=${item.slug}`}>
                  <a>
                    <Button basic size="small">
                      {t('common.articles.readMore')}
                    </Button>
                  </a>
                </Link>
              </div>
            </If>
          </div>
        </For>
      </div>
    </SiteView>
  )
};

ArticlesByCategoriesView.propTypes = {
  title: PropTypes.string.isRequired,
  data:  PropTypes.array
};

export default ArticlesByCategoriesView;